import lodash, { forEach, forOwn } from 'lodash'

export const init = (filterString) => {

  const filterParts = getFilterParts(filterString)
  const apiFilters = []

  const instance = {

    hard: (apiFilterName, apiFilterValue) => {
      useHard(apiFilters, apiFilterName, apiFilterValue)
      return instance
    },

    named: (filterName, apiFilterName, memberFunction) => {
      useNamed(filterParts, filterName, apiFilters, apiFilterName, memberFunction)
      return instance
    },

    parse: (filterPartName, apiAttributeName, memberFunction) => {
      useAnnotated(filterParts, apiFilters, filterPartName, apiAttributeName, memberFunction)
      return instance
    },

    parseAll: () => {
      useAllAnnotated(filterParts, apiFilters)
      return instance
    },

    build: () => {
      return apiFilters
    },

    extractFilter: (filterPartName) => {
      return extractFilter(filterParts, filterPartName)
    }
  }

  return instance
}


function getFilterParts(filterString) {

  const filterParts = []

  if (filterString) {
    const filterObject = JSON.parse(filterString)

    forOwn(filterObject, (value, key) => {
      filterParts.push({
        name: key,
        value
      })
    })
  }
  return filterParts
}


function useHard(apiFilters, apiFilterName, apiFilterValue) {

  apiFilters.push({
    name: apiFilterName,
    value: apiFilterValue
  })
}


function useNamed(filterParts, filterName, apiFilters, apiFilterName, memberFunction) {

  const extractedFilterPart = extractFilter(filterParts, filterName)

  if (extractedFilterPart) {
    const filterValue = extractedFilterPart.value

    if (filterValue && !(lodash.isArray(filterValue) && filterValue.length === 0)) {

      const apiValue = parseApiValue(filterValue, memberFunction)

      apiFilters.push({
        name: apiFilterName,
        value: apiValue
      })
    }
  }
}


function parseApiValue(filterValue, memberFunction) {

  if (lodash.isArray(filterValue)) {
    if (filterValue.length === 0) {
      return null
    }

    if (typeof memberFunction === 'function') {
      return filterValue.map(memberFunction)
    }

    return filterValue
  }

  if (typeof memberFunction === 'function') {
    return memberFunction(filterValue)
  }

  return filterValue
}


function useAnnotated(filterParts, apiFilters, filterPartName, apiAttributeName, memberFunction) {

  const filterPart = lodash.find(filterParts, part => part.name === filterPartName)

  return parseAndAddApiFilter(filterPart, apiFilters, apiAttributeName, memberFunction)
}


function useAllAnnotated(filterParts, apiFilters) {

  const extractedNames = []
  const newApiFilters = []

  forEach(filterParts, filterPart => {
    const { name } = filterPart

    const apiFilter = parseAndAddApiFilter(filterPart, apiFilters)

    if (apiFilter) {
      extractedNames.push(name)
      newApiFilters.push(newApiFilters)
    }
  })

  forEach(extractedNames, name => {
    const partIndex = lodash.findIndex(filterParts, part => part.name === name)

    if (partIndex >= 0) {
      filterParts.splice(partIndex, 1)
    }
  })

  return newApiFilters
}


function extractFilter(filterParts, filterName) {

  if (!filterParts || !filterParts.length) {
    return null
  }

  const partIndex = lodash.findIndex(filterParts, part => part.name === filterName)
  const result = partIndex >= 0
    ? filterParts[partIndex]
    : null

  if (partIndex >= 0) {
    filterParts.splice(partIndex, 1)
  }

  return result
}


function parseAndAddApiFilter(filterPart, apiFilters, apiAttributeName, memberFunction) {

  if (!filterPart) {
    return null
  }

  const { name } = filterPart

  const value = parseApiValue(filterPart.value, memberFunction)

    if (name.includes('@')) {
    const nameParts = name.split('@')
    const attributeName = apiAttributeName || nameParts[0]
    const operator = getApiOperatorFrom(nameParts[1])

    if (operator && !(operator === 'IN' && !value)) {
      const apiFilter = {
        attributeName,
        operator,
        value
      }

      apiFilters.push(apiFilter)
      return apiFilter
    }
  }

  return null
}


function getApiOperatorFrom(operator) {
  if (operator) {
    switch (operator.toUpperCase()) {
      case 'EQ':
      case 'NE':
      case 'LT':
      case 'LTE':
      case 'GT':
      case 'GTE':
      case 'LIKE':
      case 'IN':
        return operator.toUpperCase()

      default:
        console.error(`Unsupported operator ${operator} for api grid filter`)
        return null
    }
  }
}
